import React from "react";
import gs, { colors } from "gstyles";
import Link from "components/common/Link";

const Header = () => {
  return (
    <div className="w-full h-[var(--header-height)]">
      <div className="fixed top-0 left-0 w-full h-[460px] bg-primary z-[-1]"></div>
      <header className="relative w-full flex items-center h-[var(--header-height)] bg-primary">
        <div className="container mx-auto px-6 flex items-center">
          <div className="sm:hidden">
            <Link href="/">
              {gs.icons({
                name: "logo-black",
                width: 100,

                color: colors.white,
              })}
            </Link>
          </div>
          <div className="hidden sm:block">
            <Link href="/">
              {gs.icons({
                name: "logo-black",
                width: 140,

                color: colors.white,
              })}
            </Link>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
